import { render, staticRenderFns } from "./formerUniverse.vue?vue&type=template&id=d7c72eb0"
import script from "./formerUniverse.vue?vue&type=script&lang=js"
export * from "./formerUniverse.vue?vue&type=script&lang=js"
import style0 from "./formerUniverse.vue?vue&type=style&index=0&id=d7c72eb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports